import MyTypes from 'MyTypes';
import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Form, Image, Table, Card } from 'react-bootstrap';
import * as models from '../../models';
import dateFormat from 'dateformat';
import SingleActionButton from 'components/common/SingleActionButton'; 
import downloadIcon from '../../assets/images/Blue/download.svg';
import GearButton from 'components/common/GearButton';
import { USER_PERMISSIONS } from 'store/enums';
import { userHasPermission } from 'utils/helpers';
import sortDesc from '../../assets/images/sort-up.svg'; 
import sortAsc from '../../assets/images/sort-down-alt.svg'; 
import { claimsActions } from 'store/claims';
import AssignClaimModal from '../claim-details/AssignClaimModal'; 
import _ from 'lodash'; 
import { goto, url } from 'services/router-service';

interface Props extends PropsFromRedux {
    title: string; 
    isSortable: boolean; 
    isSelectable: boolean; 
}

interface State {
    sortField: string,
    isDesc: boolean,    
    selectedClaims: number[], 
    selectAll: boolean,
    showAssignModal: boolean, 
}
class ClaimList extends React.Component<Props, State> {
    public state = {
        sortField: this.props.claimsRequest.sort,
        isDesc: true, 
        selectedClaims: new Array<number>(), 
        selectAll: false, 
        showAssignModal: false, 
    };

    componentDidUpdate(prevProps: any, prevState: any) {
        const { claimsListResponse } = this.props; 

        if(!_.isEqual(prevProps.claimsListResponse, claimsListResponse) && claimsListResponse.totalCount === 1){
            const claimId = claimsListResponse.resourceList[0].claimID.toString(); 
            goto(url.claimProfile.replace(':claimId', claimId)); 
        }
    }
    
    public sortTable(e: any) {        
        const currentSortField = this.props.claimsRequest.sort.replace("-",""); 
        const newSortField = e.target.id;         
        
        if (newSortField === "selectAll") return;         
        
        const isFieldChanged = !(newSortField == currentSortField); 
        let isDesc = this.state.isDesc ; 
        if (isFieldChanged) {
            isDesc = (isFieldChanged ? !this.state.isDesc : false); 
            this.setState({sortField: newSortField, isDesc: isDesc});
        }
        else {
            isDesc = !isDesc; 
            this.setState({isDesc: isDesc});
        }

        const claimsRequest: models.ClaimsRequest = {
            ...this.props.claimsRequest, 
            sort: (isDesc ? "-" : "") + (isFieldChanged ? newSortField : currentSortField)
        }
        this.props.requestClaims(claimsRequest); 
    }

    public exportClaims = async () => {
        const exportQuery: models.ClaimsRequest = {
            ...this.props.claimsRequest,
            pageNo: 1,
            pageSize: this.props.claimsListResponse.totalCount,
        }
        await this.props.requestClaimCSV(exportQuery); 
    }
    
    public toggleClaim = (e: any) => {
        const { selectedClaims } = this.state; 
        let selectAll: boolean = false; 

        const id: number = parseInt(e.target.value); 
        if (!selectedClaims.includes(id))
        {            
            var list: number[] = selectedClaims; 
            list.push(id); 
            if(selectedClaims.length === this.props.claimsListResponse.resourceList.length)
                selectAll = true; 
        }
        else list = selectedClaims.filter(i => i !== id);
        
        this.setState({selectedClaims: list, selectAll: selectAll});      
    }

    public toggleSelectAll = () => {
        var list: number[] = this.state.selectedClaims;  
        let selectAll: boolean = false; 
        if (list.length === this.props.claimsListResponse.resourceList.length) {
            list = new Array<number>();
        }
        else {            
            {this.props.claimsListResponse.resourceList?.map((x: models.ClaimsList, i: number) => (
                !this.state.selectedClaims.includes(x.claimID) && list.push(x.claimID)                                
            ))}
            selectAll = true; 
        }        
        this.setState({selectedClaims: list, selectAll: selectAll});     
    }        

    public toggleShowAssignModal = () => {        
        this.setState({showAssignModal: !this.state.showAssignModal}); 
    }

    public render() {
        const { claimsListResponse, isClaimsListDownloading, title, isLoading, isSelectable, isSortable } = this.props;
        const { selectedClaims, selectAll, showAssignModal } = this.state; 

        const sortField = this.props.claimsRequest.sort.replace("-", ""); 
        const { isDesc } = this.state; 
        const selectorEnabled = userHasPermission(USER_PERMISSIONS.ASSIGNMENT_QUEUE) && isSelectable; 
        
        let buttonActions: models.ButtonAction[] = []; 
        if (userHasPermission(USER_PERMISSIONS.ASSIGNMENT_QUEUE)) {
            buttonActions = buttonActions.concat({
                name: 'Assign', 
                callBack: () => this.toggleShowAssignModal(), 
            }); 
        }

        return (
            <>
                <AssignClaimModal
                    claimsList={this.state.selectedClaims}
                    showModal={showAssignModal}
                    closeModal={this.toggleShowAssignModal}
                />            
                <Card className="claim-card">                
                    {isClaimsListDownloading && 
                        <span>Downloading...</span> 
                    }
                    <Card.Title style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <Col>
                            {title}    
                        </Col>
                        <Col>
                            <Col>
                            <SingleActionButton
                                action="Export"
                                title="Claims"
                                img={downloadIcon}
                                onClick={this.exportClaims}
                                disabled={isClaimsListDownloading}
                            />   
                            </Col>                                             
                            <Col>
                            {isSelectable && buttonActions.length > 0 && selectedClaims.length > 0 &&
                                <div style={{overflow:'visible', float: "right", width: "50px"}}>
                                    <GearButton 
                                        actions={buttonActions}
                                        rowId=''                                    
                                    />
                                </div>                                                    
                            }
                            </Col>
                        </Col>
                    </Card.Title>
                    {isLoading 
                        && <span>Loading...</span> 
                    }   
                    {claimsListResponse?.totalCount == 0 && !isLoading &&
                    <div>0 results found</div>
                    }
                    {claimsListResponse?.totalCount > 0 &&
                        <Table striped>
                            <thead>
                                <tr 
                                    className="claim-table-header"
                                    onClick={this.sortTable.bind(this)}
                                    >
                                    {selectorEnabled && 
                                        <th>
                                            <Form>
                                                <Form.Group as={Col} controlId="selectAll">
                                                    <Form.Check 
                                                        name="selectAll"
                                                        type="checkbox"
                                                        id="selectAll"
                                                        checked={selectAll}
                                                        onChange={this.toggleSelectAll}
                                                    />                                
                                                </Form.Group>
                                            </Form>
                                        </th>
                                    }
                                    <th id="claimNumber">Claim Number
                                        {isSortable && sortField ==="claimNumber" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="status">Status
                                        {isSortable && sortField ==="status" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="insCompany">Ins Company
                                        {isSortable && sortField ==="insCompany" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="insuredName">Insured
                                        {isSortable && sortField ==="insuredName" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="examinerName">Examiner
                                        {isSortable && sortField ==="examinerName" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="adjusterName">Adjuster
                                        {isSortable && sortField ==="adjusterName" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="dateLoss">Loss
                                        {isSortable && sortField ==="dateLoss" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="dateReported">Reported
                                        {isSortable && sortField ==="dateReported" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="dateReceived">Received
                                        {isSortable && sortField ==="dateReceived" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="dateReopened">Re-Opened
                                        {isSortable && sortField ==="dateReopened" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                    <th id="dateClosed">Closed
                                        {isSortable && sortField ==="dateClosed" && <Image src={isDesc ? sortDesc : sortAsc}/>}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {claimsListResponse?.resourceList?.map((claim: models.ClaimsList, i: number) => (
                                    <tr key={claim.claimID}>
                                        {selectorEnabled && 
                                            <td>
                                                <Form>
                                                    <Form.Group as={Col} controlId="isChecked" className="input-field-container">
                                                        <Form.Check 
                                                            name="isChecked"
                                                            type="checkbox"
                                                            id="chkSelected"
                                                            value={claim.claimID}
                                                            checked={selectedClaims.includes(claim.claimID)}
                                                            onChange={(e) => this.toggleClaim(e)}
                                                        />                                
                                                    </Form.Group>
                                                </Form>
                                            </td>
                                        }
                                        <td><Link to={"/claim/" + claim.claimID}>{claim.insClaimNumber}</Link></td>
                                        <td>{claim.status}</td>
                                        <td>{claim.insuranceCompany}</td>
                                        <td>{claim.insuredPerson}</td>
                                        <td>{claim.examiner?.name}</td>
                                        <td>{claim.adjuster?.name}</td>
                                        <td>{claim.dateLoss && dateFormat(claim.dateLoss, 'mm/dd/yyyy')}</td>
                                        <td>{claim.dateReported && dateFormat(claim.dateReported, 'mm/dd/yyyy')}</td>
                                        <td>{claim.dateReceived && dateFormat(claim.dateReceived, 'mm/dd/yyyy')}</td>
                                        <td>{claim.dateReopened && dateFormat(claim.dateReopened, 'mm/dd/yyyy')}</td>
                                        <td>{claim.dateClosed && dateFormat(claim.dateClosed, 'mm/dd/yyyy')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    }                
                </Card>
            </>
        );
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
    claimsListResponse: state.claims.search.claimsListResponse,
    isLoading: state.claims.search.isClaimsListLoading,
    claimsRequest: state.claims.search.claimsRequest, 
    isClaimsListDownloading: state.claims.search.isClaimsListDownloading, 
});

const mapDispatchToProps = (dispatch: Dispatch) => 
    bindActionCreators(
        {
            requestClaims: claimsActions.requestClaims,
            requestClaimCSV: claimsActions.requestClaimCSV,
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>
    
export default connector(ClaimList); 